/**
 * The bell, made real. `notifications` existed since migration 000 but was
 * never read by the app — the dropdown showed mock data. Migration 168 §6
 * closed its anon-open INSERT policy and scoped select/update to
 * `user_id = auth.uid()`, so these calls need no explicit user filter: RLS is
 * the filter. Inserts are service-role only, from portal-api and portal-admin.
 */
import { supabase } from '@/lib/supabase';

export interface AppNotification {
  id: string;
  notification_type: string;
  title: string;
  message: string | null;
  property_id: string | null;
  entity_type: string | null;
  entity_id: string | null;
  action_url: string | null;
  is_read: boolean | null;
  created_at: string;
}

const COLUMNS =
  'id, notification_type, title, message, property_id, entity_type, entity_id, action_url, is_read, created_at';

export async function getMyNotifications(limit = 30): Promise<AppNotification[]> {
  const { data, error } = await supabase
    .from('notifications')
    .select(COLUMNS)
    .order('created_at', { ascending: false })
    .limit(limit);
  if (error) throw error;
  return (data ?? []) as unknown as AppNotification[];
}

export async function unreadCount(): Promise<number> {
  const { count, error } = await supabase
    .from('notifications')
    .select('id', { count: 'exact', head: true })
    .eq('is_read', false);
  if (error) throw error;
  return count ?? 0;
}

export async function markRead(id: string): Promise<void> {
  const { error } = await supabase
    .from('notifications')
    .update({ is_read: true, read_at: new Date().toISOString() })
    .eq('id', id);
  if (error) throw error;
}

export async function markAllRead(): Promise<void> {
  const { error } = await supabase
    .from('notifications')
    .update({ is_read: true, read_at: new Date().toISOString() })
    .eq('is_read', false);
  if (error) throw error;
}
